export function addPremiumLabels() {
    // add premium labels
    $('#store_locator_result_list').on('wordpress_store_locator_get_results_loaded', function () {
        const $storeItems = $(this).find('.store_locator_result_list_item');
        let postIds = [];
        $storeItems.each(function () {
            const post_id = $(this).attr('id').replace('store_locator_result_list_item_', '');
            postIds.push(post_id);
        });

        $.ajax({
            url: ajaxRequestData.ajax_url,
            type: 'post',
            data: {
                action: 'get_acf_values',
                post_ids: postIds
            },
            success: function (response) {
                console.log(typeof response, response);
                let acf_values = {};
                try {
                    acf_values = JSON.parse(response);
                } catch (e) {
                    console.log("Failed to parse the response: ", e);
                    return;
                }

                $storeItems.each(function () {
                    const post_id = $(this).attr('id').replace('store_locator_result_list_item_', '');

                    // If the post_id is not in acf_values, we skip it and continue to the next iteration
                    if (!acf_values.hasOwnProperty(post_id)) {
                        return true; // continue to the next iteration
                    }

                    let premiumFeatures = acf_values[post_id];

                    // Check if premiumFeatures is an array and is not empty
                    if (Array.isArray(premiumFeatures) && premiumFeatures.length) {
                        // Create a new div
                        let $divWrapper = $('<div class="premium-labels"></div>');

                        // Generate spans and append them to the div
                        for (let i = 0; i < premiumFeatures.length; i++) {
                            let $newSpan = $('<span class="premium-labels__item">' + premiumFeatures[i] + '</span>');
                            $divWrapper.append($newSpan);
                        }

                        // Append the div to the store details
                        $(this).find('.store_locator_details').append($divWrapper);
                    }
                });
            },
            error: function (error) {
                console.log(error);
            }
        });
    });
}
export function selectOptionWithPostID() {
    const postID = ajaxRequestData.post_id;
    console.log(postID)

    const selectElement = $('select[name="store_locator_form_store_select"]');

    selectElement.find(`option[value=${postID}]`).prop({selected: true});
    selectElement.prop('readonly', true);
}

export function getCurrentPosition() {
    const customGetPositionButton = $('#store_locator_get_position_custom');

    customGetPositionButton.on('click', function(e){
        e.preventDefault();

        if (navigator.geolocation) {
            const options = {
                enableHighAccuracy: true,
                timeout: 5000,
                maximumAge: 0
            };

            navigator.geolocation.getCurrentPosition(function(position) {
                const addressField = $('input[name="store_locator_form_customer_address"]');
                if(addressField.val() === "") {
                    const currentPosition = new google.maps.LatLng(position.coords.latitude, position.coords.longitude);

                    // You may need to implement the geocodeLatLng as well
                    geocodeLatLng(currentPosition, function(address){
                        addressField.val(address);
                    });
                }
            }, function(error) {
                console.log(error);
            }, options);
        }
    });
}

function geocodeLatLng(latLng, callback){
    const geocoder = new google.maps.Geocoder;
    geocoder.geocode({'location': latLng}, function(results, status) {
        if (status === 'OK') {
            if (results[0]) {
                callback(results[0].formatted_address);
            } else {
                console.error('No results found');
            }
        } else {
            console.error('Geocoder failed due to: ' + status);
        }
    });
}

